<template>
    <div class="alert alert-dismissible fade show" :class="'alert-' + type" role="alert">
        <h4 class="alert-heading d-flex align-items-center">
            <svg
                :width="iconSize"
                :height="iconSize"
                fill="currentColor"
                class="me-2"
                v-if="showIcon"
            >
                <use :xlink:href="'/assets/icons/bootstrap-icons.svg#' + icon" />
            </svg>
            <div v-html="header"></div>
        </h4>
        <div v-html="body"></div>
        <hr />
        <p class="mb-0" v-html="footer"></p>

        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="x"></button>
    </div>
</template>

<script>
    export default {
        name: 'AlertDetail',
        props: {
            type: {
                type: String,
                default: "light",
            },
            header: {
                type: String,
                default: "",
            },
            body: {
                type: String,
                default: "",
            },
            footer: {
                type: String,
                default: "",
            },
            showIcon: {
                type: Boolean,
                default: true,
            },
            icon: {
                type: String,
                default: "info-circle",
            },
            iconSize: {
                type: Number,
                default: 20,
            },
        },
        setup() {},
    };
</script>